import React from 'react';
import { Link } from 'react-router-dom';
import { fmtQ } from '@/components/po/PoLinePicker';
import { money, qtyText } from '@/services/grnApi';

/** GRN lines priced at the PO rates + the GST split and totals (preview before finalising, or a finalised GRN). */
export const GrnLinesTable = ({ lines, totals, gstType, testId = 'grn-lines' }) => {
  const intra = gstType === 'CGST_SGST';
  return (
    <div className="space-y-3" data-testid={testId}>
      <div className="overflow-x-auto rounded-lg border">
        <table className="w-full text-sm">
          <thead className="bg-[#1A1F2E] text-xs text-white">
            <tr><th className="p-2 text-left">PO / Item</th><th className="p-2 text-right">Qty</th><th className="p-2 text-right">Rate</th>
              <th className="p-2 text-right">Taxable</th><th className="p-2 text-right">GST</th><th className="p-2 text-right">Total</th></tr>
          </thead>
          <tbody>
            {lines.map((l) => (
              <tr key={l.po_item_id} className="border-t" data-testid={`${testId}-row-${l.po_item_id}`}>
                <td className="p-2"><Link to={`/po/${l.po_id}`} className="font-mono text-xs text-blue-700 hover:underline">{l.po_number}</Link>
                  <div className="text-gray-900">{l.supplier_design_name}</div>
                  <div className="text-[11px] text-gray-500">{[l.sort_nos?.join(', '), l.fg_barcode && `FG ${l.fg_barcode}`, l.hsn && `HSN ${l.hsn}`].filter(Boolean).join(' · ')}</div></td>
                <td className="p-2 text-right tabular-nums">{fmtQ(l.qty)} {l.unit}</td>
                <td className="p-2 text-right tabular-nums">{money(l.rate)}</td>
                <td className="p-2 text-right tabular-nums">{money(l.amount)}</td>
                <td className="p-2 text-right tabular-nums">{money(l.tax_amount)}<div className="text-[11px] text-gray-500">@{l.tax_pct}%</div></td>
                <td className="p-2 text-right font-semibold tabular-nums">{money(l.total)}</td>
              </tr>))}
          </tbody>
        </table>
      </div>
      {totals && (
        <div className="ml-auto w-full max-w-xs space-y-1 rounded-lg border bg-[#F5F3EC] p-3 text-sm" data-testid={`${testId}-totals`}>
          <Row k="Total qty" v={qtyText(totals.qty_by_unit)} />
          <Row k="Taxable value" v={money(totals.taxable)} />
          {intra ? <><Row k="CGST" v={money(totals.cgst)} /><Row k="SGST" v={money(totals.sgst)} /></> : <Row k="IGST" v={money(totals.igst)} />}
          <div className="flex justify-between border-t pt-1 text-base font-bold" data-testid={`${testId}-grand`}><span>Grand total</span><span className="tabular-nums">{money(totals.grand_total)}</span></div>
        </div>
      )}
    </div>
  );
};

const Row = ({ k, v }) => <div className="flex justify-between"><span className="text-gray-600">{k}</span><span className="tabular-nums">{v}</span></div>;

export default GrnLinesTable;
